<template>
  <div class="page">
    <TipsHbrb ref="child"></TipsHbrb>
    <PageLoading v-if="loading"></PageLoading>
    <div class="topBanner">
      <img src="@/assets/images/blind/topImg.png" alt="">
    </div>
    <div class="moreBtn" @click="showPageLink">更多资讯</div>
    <div class="actNote" @click="showNoticePup">活动说明</div>
    
    <div class="cateBox">
      <div class="topbtn" @click="showCate = true">
        <div class="select"><i class="huodong icon-z044"></i></div>
        <div class="txt">请选择盲盒种类</div>
        <div class="select"><i class="huodong icon-z044"></i></div>
      </div>
      <div class="btnBox">      
        <div class="btn" v-for="(cate, index) in prizeCateList" :key="index" @click="toLucky(cate)">
          <div class="left"></div>
          <div class="txt">{{cate.cname}}</div>
          <div class="right"></div>
        </div>
      </div>
    </div>


    <!-- 活动规则 -->
    <van-popup v-model="showNotice" closeable close-icon="close" round>          
      <div class="noticBox">        
        <h2 class="noticTitle">
          <span class="line"></span>
          <span class="text">活动说明</span>
          <span class="line"></span>
        </h2>
        <div class="noticTxt" v-html="this.actExtend.explain"></div>
      </div>
    </van-popup>
    <navBar></navBar>  
    <!-- 1电脑端，2微信端，3纵览新闻客户端，4河北日报客户端，5H5端 -->
    <stat :actId="actInfo.lotteryid" :actTitle="actInfo.title" :from="4" v-if="actInfo && actInfo.lotteryid"></stat>
  </div>
</template>

<script>

//纵览顶部提示栏及唤起app
import TipsHbrb from '@/components/TipsHbrb.vue'
import PageLoading from '@/components/PageLoading.vue'
import Word3D from '@/components/wordCloud3D'
import navBar from '@/components/navBar.vue'
import stat from '@/components/stat.vue'
import {reqWxAuthorize} from '@/api/index.js'
import {reqLotteryInfo, reqLotteryExtend } from '@/api/lotteryHbrb.js'
import Cookies from 'js-cookie'
import {isWeixin,wxAuthorize, removeQueryParam} from "@/utils/wx-authorize.js" //微信授权
//分享
import { wxShare } from '@/utils/wxshare-wes2.com.js'
import { Dialog } from 'vant';
export default {
  name: 'index',
  components: {
    TipsHbrb, PageLoading, Word3D, navBar, stat
  },
  data () {
    return {
      loading: true,
      lotteryid:0,
      token:"",
      accessid:'', 
      openid:'', //微信用户openid   
      title:"",       
      actInfo:{},   
      actExtend:{},
      prizeCateList:[],
      prizeList:[],
      showNotice:false,
      shareImg:"https://img2.hebnews.cn/img/home.53fe0d7.png",
      shareTitle:"",
      shareDesc:"", 
      currDis:0,
      showCate:false,
      showOpen:false,
    }
  },  
  created (){
      let lotteryid = this.$route.query.lotteryid;
      this.lotteryid = this.$route.query.lotteryid;
      this.cateid = this.$route.query.cateid;
      this.token = this.$store.state.token;
      this.accountId = this.$store.state.accountId;
      this.uniqueId = this.$store.state.uniqueId;
      this.actInfo = this.$store.state.actInfo;
      this.shareImg = this.$store.state.actInfo.share_logo;
      this.shareTitle = this.$store.state.actInfo.share_title;
      this.shareDesc = this.$store.state.actInfo.share_desc;

      this.prizeCateList = this.$store.state.cateData;
  },
  mounted () {

    if(this.lotteryid) {
     this.loading = false;
    } else {
      this.$toast({
        icon: 'warning-o',
        message: '活动不存在'
      });
    }
  },  
  computed: {},
  methods: {  
    
    switchShow(){
      this.showOpen = !this.showOpen
    },
    showPageLink(){
      window.location.href = "https://hbxw.hebnews.cn/subject.html?id=618726&template=0";   
    },
    showNoticePup() {      
      this.actExtend = this.$store.state.actExtend;
      if(!this.actExtend) {
        this.showNotice = true;
      } else {
        this.loading = true;
        reqLotteryExtend({lotteryid:this.lotteryid}).then(res => {        
          if(res.code==200) {       
            this.loading = false;
            this.actExtend = res.data;   
            this.$store.commit("SET_ACTEXTEND",res.data); 
            this.showNotice = true;
          } else {
            this.loading = false;
            this.$toast({
                icon: 'warning-o',
                message: res.msg
            });
          }
        }).catch(err => {     
          this.loading = false;   
          this.$toast({
              icon: 'warning-o',
              message: err
          });
        }) 
      }
    },
    setCurr(curr){
      this.currDis = (curr==0) ? 0 :1
    },
    openBox(index) {
      if (this.activeBox === index) {
        this.activeBox = -1
        void this.$el.offsetHeight // 强制回流，重置动画
        this.activeBox = index
        return
      }
      this.activeBox = index
    },
    toLucky(cate){
      this.$router.push({ path: '/lottery',query:{...this.$route.query, cateid:cate.cateid} })
    },

  }
  
}
</script>

<style>
  @media screen and (min-width: 1200px) {
    html,body { 
      display: flex; 
      justify-content: center; 
      font-size: 190px!important;
      overflow-x: hidden;
      width: 100%;
    }
  }
  .van-toast{
    width: 240px;
  }
</style>
<style lang="scss" scoped>
@import '@/assets/css/cate.scss';
</style>